import { GetReviewSummaryQueryVariables } from '@app/data/shop-bff';
import { ReviewSummary } from '@app/types/shop-bff/types';
import { publicShopBffSdk } from '@app/utils/common';
import { useCallback, useState } from 'react';

type ReviewSummaryState = {
  reviewSummary?: ReviewSummary | null;
  loading: boolean;
};
// cache to not call API after repeated co-listing switches
const cache = new Map<string, ReviewSummaryState>();

export const useReviewSummary = (
  initialProductTypeId: string,
  initialReviewSummary?: ReviewSummary | null
) => {
  const [{ reviewSummary, loading }, setReviewSummary] = useState<{
    reviewSummary?: ReviewSummary | null;
    loading: boolean;
  }>({
    reviewSummary: initialReviewSummary,
    loading: !initialReviewSummary,
  });
  cache.set(initialProductTypeId, {
    reviewSummary: initialReviewSummary,
    loading: !initialReviewSummary,
  });

  const refresh = useCallback(
    (variables: GetReviewSummaryQueryVariables, productTypeId: string) => {
      const cachedReviewSummary = cache.get(productTypeId);
      if (cachedReviewSummary) {
        setReviewSummary(cachedReviewSummary);
      } else {
        setReviewSummary({ reviewSummary: null, loading: true });
        publicShopBffSdk
          .GetReviewSummary(variables)
          .then((res) => {
            cache.set(productTypeId, {
              reviewSummary: res.shop_reviewSummary,
              loading: false,
            });
            setReviewSummary({
              reviewSummary: res.shop_reviewSummary,
              loading: false,
            });
          })
          .catch(() => {
            // TODO: Handle errors
            setReviewSummary({
              reviewSummary: null,
              loading: false,
            });
          });
      }
    },
    []
  );

  return {
    reviewSummary,
    loading,
    refresh,
  };
};
